import { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const useAutoLogout = () => {
  const navigate = useNavigate();

  // Define logout function with useCallback
  const logoutUser = useCallback(() => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("username");
    localStorage.removeItem("expiresAt");
    navigate("/login"); // Redirect to login page
  }, [navigate]);

  useEffect(() => {
    const expiresAt = localStorage.getItem("expiresAt");

    if (expiresAt) {
      const expirationTime = parseInt(expiresAt, 10) - Date.now();
      
      if (expirationTime <= 0) {
        logoutUser(); // If expired, log out immediately
      } else {
        const timeout = setTimeout(logoutUser, expirationTime);
        return () => clearTimeout(timeout); // Cleanup on unmount
      }
    }
  }, [logoutUser]); // Now, logoutUser is included in dependencies

};

export default useAutoLogout;
